class CartDrawerReviews extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    // Ensure the element has the Flickity class and images to display
    if (this.classList.contains("flickity") && this.children.length) {
      this.initializeCarousel();
    } else {
      console.error(
        "CartDrawerReviews: No valid content or Flickity class missing."
      );
    }
  }

  disconnectedCallback() {
    if (this.carousel) {
      this.carousel.unload(); // Unload Flickity when element is removed
    }
  }

  initializeCarousel() {
    // Wait for images to load before initializing Flickity
    this.waitForImagesToLoad(() => {
      const prevButton = this.querySelector("[data-prev-button]") || null;
      const nextButton = this.querySelector("[data-next-button]") || null;

      this.carousel = new theme.Carousel(
        this,
        {
          prevNextButtons: false,
          adaptiveHeight: true,
          pageDots: true,
          contain: true,
          cellAlign: "center",
          groupCells: false, // Show one slide at a time
          rightToLeft: theme.config.rtl,
        },
        { previous: prevButton, next: nextButton }
      );

      this.carousel.load(); // Initialize Flickity carousel

      // Force Flickity to update its dimensions
      this.carousel.slider.reloadCells();
      this.carousel.slider.resize();
      window.dispatchEvent(new Event("resize")); // Trigger global resize
    });
  }

  waitForImagesToLoad(callback) {
    const images = this.querySelectorAll("img");
    const totalImages = images.length;
    let loadedCount = 0;

    if (!totalImages) {
      callback(); // No images to load
      return;
    }

    images.forEach((img) => {
      if (img.complete) {
        loadedCount++;
        if (loadedCount === totalImages) callback();
      } else {
        img.addEventListener("load", () => {
          loadedCount++;
          if (loadedCount === totalImages) callback();
        });
        img.addEventListener("error", () => {
          loadedCount++;
          if (loadedCount === totalImages) callback();
        });
      }
    });
  }
}

customElements.define("cart-drawer-reviews", CartDrawerReviews);
document.addEventListener("page:loaded", function () {
  window.dispatchEvent(new Event("resize")); // Trigger global resize
});
